module.exports = __webpack_public_path__ + "img/buddy_mouth-01.99b1a76b.svg";